if (window.location.pathname.includes("/pages/")) {
    const loop = setInterval(() =>{
      const submitBtn = document.querySelector(".bss-b2b-rf-submit-button");
      if (submitBtn) {
          clearInterval(loop);
          const accountForm = document.createElement("div");
          accountForm.className = "account__form-row text-size--small";
          accountForm.innerHTML = `Already have an account? <a href="/account/login">Login</a>`;
  
          submitBtn.insertAdjacentElement('afterend', accountForm);
      }
    }, 200)

    setTimeout(() =>{
      clearInterval(loop);
    }, 5000)
    
}

if (window.location.pathname.includes("/account/login")) {
    const registerLink = document.querySelector("#customer_register_link");
    if(registerLink) {
      registerLink.setAttribute("href", "/pages/become-a-partner");
    }
}

setTimeout(() => {
  if(window.location.pathname === '/cart'){
    let interval = setInterval(() => {
      const recommentdProducts = document.querySelector('product-recommendations .cart-product-recommendations');
      if(recommentdProducts){
        clearInterval(interval);
        window.dispatchEvent(new Event('scroll'));
      }
    }, 200)
    setTimeout(() => {
      clearInterval(interval);
    }, 5000);

    //dc + te
    // setTimeout(() => {
    //   const dc = document.querySelector('.bss-b2b-discount-code-wrapper.bss-config-header');
    //   const te = document.querySelector('.bss-b2b-tax-ex-wrapper.bss-config-header');
    //   const cart_total = document.querySelector('.cart-section #AjaxCartSubtotal .cart__total');
    //   if(dc && cart_total){
    //     cart_total.append(dc);
  
    //   }
    //   if(te && cart_total){
    //     cart_total.append(te);
    //   }
    // }, 1000)

  }

   const dc_btn = document.querySelector('#bss-b2b-discount-code-submit');
        if(dc_btn){
            dc_btn.addEventListener('click', () => {
              BSS_B2B.td.utils.cart.initPriceList();
              BSS_B2B.observer.cartSubject.notifyObserver('CartUpdate', 'CartMutate');
            })
        }

  if(window.location.pathname.includes('/products/')){
    const btn = document.querySelector('.add-to-cart');
    const input = document.querySelector('product-quantity input[type="number"]')
    const checkQuantity = (appliedRule, quantity) => {
      const qtyIncrementMax = appliedRule.qty_increment_max ? appliedRule.qty_increment_max : Infinity;
      const qtyIncrementMin = appliedRule.qty_increment_min ? appliedRule.qty_increment_min : 0;
      if (quantity % appliedRule.qty_increment !== 0 || quantity > qtyIncrementMax || quantity < qtyIncrementMin) {
        return false;
      }
      return true;
    }
    if(btn && input){
      btn.addEventListener('click', (event) => {
          const productForm = document.querySelector('[bss-b2b-product-form-id]');
            if(productForm){
                const formId = productForm.getAttribute('bss-b2b-product-form-id');
                if(formId){
                    const rule = BSS_B2B.qi.utils.product.qiMessageMap.get(formId).qiRule;
                    const quantity = input.value;
                    if(!checkQuantity(rule, quantity) ){
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                            }
                    }
                }

            })
    }

    //variant change
    const variantOptions = document.querySelectorAll('.product-variant__item input');
      if(variantOptions.length){
          variantOptions.forEach(item => {
              item.addEventListener('click', (event) =>{
                  const productForm = document.querySelector('[bss-b2b-main-product-form]')
              BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {event,productForm});
          })
          })
      }
  }

  //variant change quickview
  const quickAddBtn = document.querySelectorAll('.quick-add-to-cart a');
  if(quickAddBtn.length){
    quickAddBtn.forEach(btn => {
      btn.addEventListener('click', () => {
        setTimeout(() => {
          document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`));
            const variantOptions = document.querySelectorAll('modal-box.active .product-variant__item input');
            if(variantOptions.length){
                variantOptions.forEach(item => {
                    item.addEventListener('click', (event) =>{
                        const productForm = document.querySelector('modal-box.active [bss-b2b-quickview-product-form]')
                    BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {event,productForm});
                })
                })
            }
        }, 1000)
      })
    })
  }


}, 300)
